(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.SidebarController = (function(superClass) {
    extend(SidebarController, superClass);

    function SidebarController(scope, transitions, repo, loader, $q, state, modal) {
      var things_to_load;
      this.scope = scope;
      this.transitions = transitions;
      this.repo = repo;
      this.state = state;
      this.modal = modal;
      this.showError = bind(this.showError, this);
      this.showLoadCropsError = bind(this.showLoadCropsError, this);
      this.loadCrops = bind(this.loadCrops, this);
      SidebarController.__super__.constructor.call(this, this.scope, this.transitions);
      loader.overSidebar('Loading...');
      things_to_load = [this.loadCrops()];
      $q.all(things_to_load).then((function(_this) {
        return function(result) {
          return loader.hideAll();
        };
      })(this));
      if (this.state.is('portal.ratings')) {
        this.state.go('portal.ratings.setup', null, {
          location: 'replace'
        });
      }
      this.scope.crops = [];
      this.scope.selected = {
        crop: null
      };
      this.scope.$state = this.state;
    }

    SidebarController.prototype.loadCrops = function() {
      var promise;
      promise = this.repo.getCrops().then((function(_this) {
        return function(response) {
          var crop, i, len, ref, ref1, ref2;
          if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
            _this.showLoadCropsError((ref1 = response.status) != null ? ref1.msg : void 0);
            return;
          }
          _this.scope.crops.length = 0;
          ref2 = response.data.crops;
          for (i = 0, len = ref2.length; i < len; i++) {
            crop = ref2[i];
            _this.scope.crops.push(crop);
          }
          if (_this.scope.crops.length === 1) {
            return _this.scope.selected.crop = _this.scope.crops[0];
          }
        };
      })(this))["catch"]((function(_this) {
        return function(response) {
          return _this.showLoadCropsError();
        };
      })(this));
      return promise;
    };

    SidebarController.prototype.showLoadCropsError = function(msg) {
      if (msg != null) {
        msg = "Failed to load Crops: " + msg;
      } else {
        msg = 'Failed to load Crops';
      }
      return this.showError(msg);
    };

    SidebarController.prototype.showError = function(msg) {
      return alert(msg);
    };

    return SidebarController;

  })(Controller);

}).call(this);
